export type SelectedImage = {
  id: number;
  uri: string;
  examinationIndex: number;
  imageIndex: number;
};

export type ComparedImage = {
  id: number;
  url: string;
};

/**
 * Parent collection is sorted newest-first, so a lower examinationIndex means
 * a newer examination and belongs on the left. Within the same examination,
 * images are ordered by their position in the case (Image 1 before Image 2).
 */
export function sortSelectedImages(
  selected: ReadonlyArray<SelectedImage>,
): ComparedImage[] {
  return [...selected]
    .sort(
      (a, b) =>
        a.examinationIndex - b.examinationIndex || a.imageIndex - b.imageIndex,
    )
    .map(({ id, uri }) => ({ id, url: uri }));
}
